import React, { useState, useEffect } from 'react';
import { auth, db } from './services/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { ThemeProvider, useTheme } from './ThemeContext';
import LoginScreen from './components/LoginScreen';
import Dashboard from './components/Dashboard';

function AppContent() {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTheme();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const adminDoc = await getDoc(doc(db, 'admins', user.uid));
          if (adminDoc.exists()) {
            const adminData = adminDoc.data();
            setAdmin({
              email: user.email,
              uid: user.uid,
              school: adminData.schoolName,
              schoolId: adminData.schoolId,
              role: adminData.role || 'Administrator',
            });
          } else {
            await auth.signOut();
            setAdmin(null);
          }
        } catch (err) {
          console.error('Error fetching admin data:', err);
          setAdmin(null);
        }
      } else {
        setAdmin(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: t.bgGradient,
        fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif",
        fontSize: 16,
        color: t.textSecondary,
      }}>
        Loading...
      </div>
    );
  }

  if (!admin) {
    return <LoginScreen onLogin={setAdmin} />;
  }

  return <Dashboard admin={admin} onLogout={() => auth.signOut()} />;
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;